// Offre d'installation : pas de bouton géré directement ici. On expose de quoi décider si
// l'installation est proposable (getMode), déclencher le geste correspondant (trigger), et
// être notifié quand la disponibilité change (onChange) — pour un bouton persistant du pied
// de page comme pour la proposition ponctuelle avant le Hall of Fame.
import { $, show, hide } from './dom.js';
import { getInstallMode } from '../core/install.js';

export function createInstallOffer() {
  const hint = $('installHintModal');
  let promptEvent = null;
  let installed = false;
  const listeners = new Set();
  const notify = () => listeners.forEach((fn) => fn());

  const isStandalone = () =>
    window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault(); // on garde l'invite pour la déclencher plus tard, à la demande
    promptEvent = e;
    notify();
  });

  window.addEventListener('appinstalled', () => {
    installed = true;
    promptEvent = null;
    notify();
  });

  /** À consulter à chaque fois (jamais mis en cache) : l'état peut changer entre deux appels. */
  function getMode() {
    if (installed) return 'none';
    return getInstallMode({
      standalone: isStandalone(),
      hasPromptEvent: Boolean(promptEvent),
      userAgent: navigator.userAgent,
    });
  }

  /**
   * Déclenche le geste d'installation : invite native si disponible, sinon aide pas à pas iOS.
   * Résout quand l'utilisateur en a fini (accepté, refusé l'invite, ou fermé l'aide) — jamais de rejet.
   */
  function trigger() {
    return new Promise((resolve) => {
      if (promptEvent) {
        const event = promptEvent;
        promptEvent = null; // une invite ne se déclenche qu'une fois
        event.prompt();
        event.userChoice.then(resolve, resolve).finally(notify);
        return;
      }
      const onClose = () => {
        hide(hint);
        $('btnCloseInstallHint').removeEventListener('click', onClose);
        resolve();
      };
      $('btnCloseInstallHint').addEventListener('click', onClose);
      show(hint);
    });
  }

  /** Notifié quand la disponibilité de l'installation change (invite détectée, appli installée). */
  function onChange(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  }

  return { getMode, trigger, onChange, isStandalone };
}
